import * as locationTypes from "Store/locations/constants";

const initialState: ILocationsReducer = {
  locations: [],
  currentLocation: null,
  activeLocation: null,
  activeLocationSummary: null,
  queryOptions: { search: "" },
  locationsLoadingSimplified: false
};

const handleActions = (action) => {
  switch (action.type) {
    case locationTypes.SET_ALL_LOCATIONS:
      return {
        locations: action.payload.locations
      };
    case locationTypes.SET_CURRENT_LOCATION:
      return {
        currentLocation: action.payload.location
      };
    case locationTypes.SET_ACTIVE_LOCATION_SUMMARY:
      return {
        activeLocationSummary: action.payload.locationSummary
      };
    case locationTypes.SET_ACTIVE_LOCATION:
      return {
        activeLocation: action.payload.location
      };
    case locationTypes.SET_LOCATIONS_SIMPLIFIED_LOADING:
      return {
        locationsLoadingSimplified: action.payload.isLoading
      };
    default:
      return {};
  }
};

const locationReducer = (state = initialState, action) => ({
  ...state,
  ...handleActions(action)
});

export default locationReducer;
